import type { Components } from '@mui/material/styles';

export default function MuiTableHead(): Components['MuiTableHead'] {
  return {
    styleOverrides: {
      root: {
        position: 'relative',
        top: 0,
        zIndex: 1,
      },
    },
  };
}
